export default __webpack_public_path__ + "static/media/logosvg.f95bf308.svg";